import React from 'react';
import './App.css';
import {Layout} from './components/Layout'
import Table_blogers from './components/Table_blogers';
// import Posts from './components/Posts';
import SingleBlogger from './components/SingleBlogger';
import NotFound from './components/NotFound';


import {Routes, Route} from 'react-router-dom';

function App() {
  return (
    <>
        <Routes>
            <Route path="/bloggers/" element={<Layout />}>
                <Route index element={<Table_blogers />} />
                <Route path=":slug" element={<SingleBlogger />} />
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    </>
  );
}

export default App;


// import React from 'react';
// import './App.css';
// import PostList from './components/PostList';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <h1>My WordPress Blog</h1>
//       </header>
//       <main>
//         <PostList />
//       </main>
//     </div>
//   );
// }

// export default App;
